/**
 * @generated SignedSource<<836d78faa7e78c2992a245ec0ffc0542>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PhotoStatus = "ACTIVE" | "DELETED" | "PENDING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSellerBrandingInfo_seller$data = {
  readonly liveStorefrontProfile: {
    readonly photos: ReadonlyArray<{
      readonly path: string | null;
      readonly status: PhotoStatus | null;
    } | null> | null;
  } | null;
  readonly sellerProfile: {
    readonly company: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedSellerBrandingInfo_seller";
};
export type PdpSharedSellerBrandingInfo_seller$key = {
  readonly " $data"?: PdpSharedSellerBrandingInfo_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerBrandingInfo_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSellerBrandingInfo_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StorefrontProfile",
      "kind": "LinkedField",
      "name": "liveStorefrontProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "photoType",
              "value": "DEALER_STOREFRONT_HEADSHOT"
            }
          ],
          "concreteType": "Photo",
          "kind": "LinkedField",
          "name": "photos",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerProfile",
      "kind": "LinkedField",
      "name": "sellerProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "company",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "e0cf54517138aa6d548665ff03f7079a";

export default node;
